import type { Dispatch, SetStateAction } from 'react';
import type { ArrowDirection } from '../components/atomic/buttons/arrows/Arrows';
import type { InfoPopupState } from '../shared/infoPopup/infoPopupState';
import {
  createVerticalArrowPositions,
  FIGMA_VERTICAL_ARROW_SCALE,
} from '../shared/verticalArrows/verticalArrows';
import { MAX_LEVEL_PAGE } from './level_cards/levelCardsData';

export const PLAYER_LEVEL_ARROW_SCALE = FIGMA_VERTICAL_ARROW_SCALE;
export const LEVEL_ARROW_POSITIONS = createVerticalArrowPositions(346);

export { MAX_LEVEL_PAGE };

export type PlayerLevelScreenProps = {
  successfulDeliveries: number;
  averageRating: number;
  onInfoClick?: () => void;
  onNavigate?: (direction: ArrowDirection) => void;
  onGoBack?: () => void;
};

export type PlayerLevelScreenState = InfoPopupState & {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
};

export type PlayerLevelScreenModel = {
  infoOpen: boolean;
  setInfoOpen: Dispatch<SetStateAction<boolean>>;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  successfulDeliveries: number;
  averageRating: number;
  onInfoClick?: () => void;
  onNavigate?: (direction: ArrowDirection) => void;
  onGoBack?: () => void;
};

export function createPlayerLevelScreenModel(
  props: PlayerLevelScreenProps,
  state: PlayerLevelScreenState,
): PlayerLevelScreenModel {
  return {
    infoOpen: state.infoOpen,
    setInfoOpen: state.setInfoOpen,
    page: state.page,
    setPage: state.setPage,
    successfulDeliveries: props.successfulDeliveries,
    averageRating: props.averageRating,
    onInfoClick: props.onInfoClick,
    onNavigate: props.onNavigate,
    onGoBack: props.onGoBack,
  };
}
